import { HTTPError } from "../Exceptions/HTTPError";
import { Product as ShopifyProduct, Variant } from "../Interfaces/Product";

/**
 * Represents a product by fetching its data from the Shopify Ajax API.
 * Currently holding only the product key, please extend with further attributes when required.
 * https://shopify.dev/docs/api/ajax/reference/product
 */
export class Product {
    private readonly handle: string;
    private productData: ShopifyProduct;

    /**
     * Init product
     * @param handle shopify handle value for the product
     */
    constructor(handle: string) {
        this.handle = handle;
        this.fetchProductData().then(/* ignore unused promise result */);
    }

    /**
     * @return {String} URL to fetch product data from
     * @protected
     */
    protected getProductUrl(): string {
        return `${window.Shopify.routes.root}products/${this.handle}.js`;
    }

    protected async fetchProductData(): Promise<void> {
        const response = await fetch(this.getProductUrl(), {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (response.status !== 200) throw new HTTPError(response.status, await response.text());
        this.productData = await response.json();
    }

    public getVariant(variantId: number): Variant {
        return this.productData.variants.find((variant) => variant.id === variantId);
    }
}
